var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19C1.95 19 1.479 18.804 1.087 18.412C0.695002 18.02 0.499335 17.5493 0.500002 17V6C0.500002 5.45 0.696002 4.979 1.088 4.587C1.48 4.195 1.95067 3.99934 2.5 4H6.5V2C6.5 1.45 6.696 0.979002 7.088 0.587002C7.48 0.195002 7.95067 -0.000664969 8.5 1.69779e-06H12.5C13.05 1.69779e-06 13.521 0.196002 13.913 0.588002C14.305 0.980002 14.5007 1.45067 14.5 2V4H18.5C19.05 4 19.521 4.196 19.913 4.588C20.305 4.98 20.5007 5.45067 20.5 6V17C20.5 17.55 20.304 18.021 19.912 18.413C19.52 18.805 19.0493 19.0007 18.5 19H2.5ZM2.5 17H18.5V6H2.5V17ZM8.5 4H12.5V2H8.5V4Z",
    fill: "#F2F7FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.1b760b07f50100eff04eaaa7907ce209.svg";
export { ForwardRef as ReactComponent };